import { createSelector } from 'reselect';
import { matchPath } from 'react-router-dom';

export const getRouterCurrentStateSelector = ({ router }) =>
  router.location.pathname;

export const getSceneNameSelector = createSelector(
  getRouterCurrentStateSelector,
  pathname => {
    for (const sceneName of [
      'entities',
      'groups',
      'intents',
      'dictionaries',
      'contexts',
    ]) {
      if (
        matchPath(pathname, {
          path: `/:company/:project/${sceneName}`,
        })
      ) {
        return sceneName;
      }
    }
    return '';
  },
);

export const getIsProjectInnerPageSelector = createSelector(
  getRouterCurrentStateSelector,
  pathname =>
    !!(
      matchPath(pathname, { path: '/:company/:project/flow' }) ||
      matchPath(pathname, { path: '/:company/:project/new-flow' }) ||
      matchPath(pathname, { path: '/:company/:project/xpacks' }) ||
      matchPath(pathname, { path: '/:company/:project/groups' }) ||
      matchPath(pathname, { path: '/:company/:project/entities' }) ||
      matchPath(pathname, { path: '/:company/:project/test-sets' }) ||
      matchPath(pathname, { path: '/:company/:project/intents' }) ||
      matchPath(pathname, { path: '/:company/:project/contexts' }) ||
      matchPath(pathname, { path: '/:company/:project/resources' }) ||
      matchPath(pathname, { path: '/:company/:project/dictionaries' }) ||
      matchPath(pathname, { path: '/:company/:project/project-settings' })
    ),
);

export const getProjectInnerPageParamsSelector = createSelector(
  getRouterCurrentStateSelector,
  pathname => matchPath(pathname, { path: '/:company/:project' }).params,
);
